import {Contact} from './Contact';
import {Folder, FolderType} from './Folder';

export interface ExtractorResponse {
  id: string;
  url?: string;
  extractor: string;
  _has_drm?: boolean;
  _filename?: string;
  _type?: string;
  _version?: string;
}

export interface MediaStateType {
  currentVideo: Media | null;
  currentVideoId: string | null;
  isLoading: boolean;
  isPlaying: boolean;
  openItemId: string | null;
  enqMedia: (media: Media) => Promise<any>;
  setOpenItem: (i: Media) => void;
  webViewUrl?: string | null;
  host?: string;
  fileParam?: string;
  webViewRef?: any;
  magnetURI?: string | null;
  onUpdateMagnet?: () => Promise<any>;
}

export interface Media extends ExtractorResponse {
  _id?: string;
  _rev?: string;
  _deleted?: boolean;
  date: number;
  isMediaNew: boolean;
  folderId: string;
  originalId: string;
  webpage_url?: string;
  title: string;
  isPlaying?: boolean;
  isDownloaded?: boolean;
  isDownloading?: boolean;
  isOpen?: boolean;
  isInfoOpen?: boolean;
  thumbnail?: string;
  currentPosition?: number;
  local?: string;
  torrentFileName?: string;
  files?: IFile[];
  magnetURI?: string;
  infoHash?: string;
  description?: string;
  filename: string;
  fileType: string;
  userId: string;
  size?: number;
  type?: string;
  hasCloud?: boolean;
  isEncoderProject?: boolean;
  width: number;
  height: number;
  orderId: number;
  duration?: number;
  isCopy?: string;
  mnemonic: string;
  image?: string;
  isAuctionMedia?: boolean;
  torrentFile?: ArrayBuffer;
  preview: Media['id'];
  isChatMedia?: true;
  audioSpectrogram_big?: string;
  audioSpectrogram_small?: string;
}

export enum FFMpegPreset {
  ultrafast = 'ultrafast',
  superfast = 'superfast',
  veryfast = 'veryfast',
  faster = 'faster',
  fast = 'fast',
  medium = 'medium',
}

export enum FFMpegOutputType {
  mp4 = 'mp4',
  gif = 'gif',
}

export interface EncoderProject extends Media {
  encoding: {
    outputFilePath?: string;
    compressionLevel: number;
    width: number;
    height: number;
    crf: number;
    preset: FFMpegPreset;
    output: FFMpegOutputType;
    code: String[];
    lastUpdated: number;
    start?: number;
    end?: number;
    soundVolume?: number;
  };
}

export interface EditorComment extends EncoderProject, Contact {
  description: string;
  isEditorComment: true;
}

export interface EditorProject extends Folder {
  isEditorProject?: boolean;
  editor: {
    length: number;
    width: number;
    height: number;
    lastUpdated: number;
    start?: number;
    end?: number;
    outputFilePath?: string;
    compressionLevel: number;
    framerate?: number;
    aspectRatio?: string;
    preset: FFMpegPreset;
    output: FFMpegOutputType;
    code?: string[];
  };
}

export interface EditorLayer extends Folder {
  isEditorLayer?: boolean;
  editor: {
    muted?: boolean;
    videoDisabled?: boolean;
    isCommentLayer?: boolean;
  };
  media?: EncoderProject[];
}

export interface MediaRes {
  docs: Media[];
}

export interface IFile {
  url: string;
  name: string;
  type: string;
}

export interface Product extends Media {
  price: number;
  isProduct: true;
  productDescription?: string;
  productName?: string;
  status: 'published' | 'draft';
}

export interface MinimalProduct {
  price: number;
  category: string;
  description: string;
  title: string;
  id: string;
  order: number;
  image: string;
}
